import { useState } from 'react';
import './App.css';

const Ai = () => {

  const links = [
    {
      url: "https://gamifiedlearning1.netlify.app/",
      imgSrc: "game.jpeg",
      text: "AI - Gamified Learning",
    },
    {
      url: "https://aifraud.netlify.app/",
      imgSrc: "fraud.jpg",
      text: "AI - Fraud Detection",
    },
    {
      url: "https://job404.netlify.app/",
      imgSrc: "job.png",
      text: "AI - Job Genuis",
    },
  ];


  const handleOkay = () => {
    window.open(links[0].url, "_blank");
  };

  return (
    <>
        <div id="dynamicLinks">
          <p style={{margin: "0px", marginBottom: "10px", fontWeight: "500", fontFamily: "cursive"}}>Artificial Intelligence - AI Projects</p>
            {links.map((link, index) => (
              <a key={index} href={link.url} target="_blank" rel="noopener noreferrer">
                <div className="main-child">
                  <div className="img-view">
                    <img src={link.imgSrc} alt={link.text} />
                  </div>
                  <div className="text">
                    <p>{link.text}</p>
                  </div>
                </div>
              </a>
            ))}
        </div>

      {/* {showPopup && <div className="overlay"></div>}
      {showPopup && (
        <div className="popup">
          <div className="popup-content">
            <p style={{width: "300px"}}>This project demonstrates authentication with MetaMask and connection to a blockchain network. If you are using a Web 2.0 browser, the functionality will not work. You need to connect with Web 3.0/MetaMask for the full functionality, otherwise, the page will remain static & account details [32 bytes hex string] no will not visible.</p>
            <button onClick={handleOkay}>Okay</button>
          </div>
        </div>
      )} */}
    </>
  );
};

export default Ai;
